import React, { createContext, useContext, useState } from "react";

const StateContext = createContext();
const initialState = {
  chat: false,
  cart: false,
  userProfile: false,
  notification: false,
};

export const ContextProvider = ({ children }) => {
  const [currentDir, setCurrentDir] = useState("rtl");
  const [currentLang, setCurrentLang] = useState("ar");
  const [currentMode, setCurrentMode] = useState('Light');
  const [activeMenu, setActiveMenu] = useState(true);
  const [isClicked, setIsClicked] = useState(initialState);
  const [screenSize, setScreenSize] = useState(undefined);
  const setLang = (lang) => {


    localStorage.setItem("themeLang", lang);
  
    const Dir = lang === "en" ? "ltr" : "rtl";
    setCurrentDir(Dir);
    setCurrentLang(lang);
    localStorage.setItem("themeDir", Dir);

  };
  const setMode = (Mode) => {
    setCurrentMode(Mode);
    localStorage.setItem('themeMode', Mode);
  };

  const handleClick = (clicked) => setIsClicked({ ...initialState, [clicked]: true });
  return (
    <StateContext.Provider
      value={{ handleClick, isClicked, initialState, setIsClicked,setCurrentLang,currentLang, setCurrentDir, currentDir, setLang,activeMenu, setActiveMenu,setScreenSize, screenSize,setMode,currentMode }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
